import anime from 'animejs'

export default async (oldContainer, newContainer, lastClickEl, done) => {
  // NOTE: This allows seemless page transition
  // SEE:  snippets/filters.* for instance
  if (lastClickEl && lastClickEl.hasAttribute('data-skip-barba-transition')) {
    return done()
  }

  const newContainerChildren = [...newContainer.children].filter(el => !el.classList.contains('menu'))
  window.scrollTo(0, 0)
  done()
  anime({
    targets: newContainerChildren,
    opacity: [0, 1],
    duration: 1000,
    easing: 'easeOutExpo'
  })
}
